import { PROMO_DISCOUNT_VIEW } from '@/utils/permissions'

export default [
  {
    path: '/promo-discount/list',
    name: 'promo-discount-list',
    component: () => import('@/views/promo-discount/PromoDiscountList.vue'),
    meta: {
      allowAnonymous: false,
      pageTitle: 'Promo Discount List',
      breadcrumb: [
        { title: 'Dashboard', url: '/dashboard' },
        { title: 'Promo Discount List', active: true }
      ],
      permissions: [PROMO_DISCOUNT_VIEW]
    }
  }
]
